import React from "react";

/*
 * Faint e-waste line icons (laptop, phone, battery, …) scattered over a
 * .sc6-band — decoration only. Positions/sizes are in Sc6.css (.sc6-deco__i--N).
 */
const ICONS = [
  <><rect x="4" y="5" width="16" height="10.5" rx="1.5" /><path d="M2 19h20" /></>,
  <><rect x="7" y="2.5" width="10" height="19" rx="2.2" /><path d="M11 18.3h2" /></>,
  <><rect x="2.5" y="7.5" width="16.5" height="9" rx="2" /><path d="M21.5 10.5v3M6.5 10.5v3M10 10.5v3" /></>,
  <><path d="M9 2.5V7M15 2.5V7" /><path d="M6.5 7h11v3.5a5.5 5.5 0 0 1-11 0z" /><path d="M12 16v5.5" /></>,
  <>
    <path d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5" />
    <path d="M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12" />
    <path d="m14 16-3 3 3 3" />
    <path d="M8.293 13.596 7.196 9.5 3.1 10.598" />
    <path d="m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843" />
    <path d="m13.378 9.633 4.096 1.098 1.097-4.096" />
  </>,
  <><rect x="7" y="7" width="10" height="10" rx="1.5" /><path d="M10 10h4v4h-4zM9.5 3v4M14.5 3v4M9.5 17v4M14.5 17v4M3 9.5h4M3 14.5h4M17 9.5h4M17 14.5h4" /></>,
  <><path d="M9 18h6M10 21h4" /><path d="M12 3a6 6 0 0 0-3.8 10.6c.6.5.8 1.3.8 2.1V16h6v-.3c0-.8.2-1.6.8-2.1A6 6 0 0 0 12 3z" /></>,
];

export default function Sc6Deco() {
  return (
    <div className="sc6-deco" aria-hidden="true">
      {ICONS.map((d, i) => (
        <svg
          key={i}
          className={`sc6-deco__i sc6-deco__i--${i + 1}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {d}
        </svg>
      ))}
    </div>
  );
}
